export enum ServiceEnum {
  SALES = 'sales',
  PROJECTS = 'projects',
  FINANCES = 'finances',
  SITES = 'sites',
  TIMESHEETS = 'timesheets',
  TRAININGS = 'trainings',
  DOCUMENTS = 'documents',
  SYSTEM_ADJUSTMENT = 'systemAdjustment',
}

export enum PermissionRules {
  canDelete = 'canDelete',
  canEdit = 'canEdit',
  canRead = 'canRead',
  canCreate = 'canCreate',
  canClone = 'canClone',
  canTimesheetApproval = 'canTimesheetApproval',
  canSubmitBid = 'canSubmitBid',
  canEditLivePaperwork = 'canEditLivePaperwork',
  canRemoveComments = 'canRemoveComments',
}
